import { Dispatch } from 'redux';
import { axiosV2 } from 'interceptors/axios';

import { ApiQueryParams } from 'types';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetCoOwnerSharesProps = {
  partnerId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getCoOwnerShares =
  ({ partnerId, params, signal }: GetCoOwnerSharesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/shares/coOwners', {
        params: { partnerId, ...params },
        // signal
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
